<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Mad Mix</h1>
<p class="BOD2">Add a bow tie to a skull, create a bagful of candy or mix a sunny face with a lightning bolt – who says you can’t!</p>
<p class="IMAGE"><img alt="" src="images/C1-15.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-16.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-8.vue?0c80e820